<script setup>
import { cleanNodeName } from '../../composables/formatUtils'
</script>

<template>
  <div class="kpiSet-tree">
    <div class="py-2 border-bottom border-dark" :class="!depth ? 'd-none' : ''">
      <div :style="indent">
        <div class="cont-icon-kpi d-inline-block me-1">
          <svg class="bi" width="16" height="16" fill="currentColor">
            <use v-if="node.level == 0" xlink:href="@/assets/icons/icons.svg#folder"/>
            <use v-else xlink:href="@/assets/icons/icons.svg#kpi"/>
          </svg>
        </div>
        <div class="d-inline-block tree-node-name">
          <span @click="selectKPISet(node)" class="kpiSet-name" :class="selectedKPISet.id === node.id ? 'fw-bold' : ''" role="button">{{ cleanNodeName(node.name) }}</span>
        </div>
      </div>
    </div>
    <div v-if="filteredNode && showNodes">
      <KPISetTree v-for="node in filteredNode.nodes" :key="node.id" :node="node" :depth="depth + 1" :mode="mode" :searchText="searchText" :autoOpenDepth="autoOpenDepth"></KPISetTree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KPISetTree',
  props: {
    node: Object,
    depth: Number,
    mode: String,
    searchText: String,
    autoOpenDepth: Number
  },

  data () {
    return {
      showNodes: this.depth < this.autoOpenDepth
    }
  },
  computed: {
    filteredNode () {
      return this.filterNode(this.node, this.searchText)
    },
    indent () {
      if (this.node.nodes && this.depth) {
        return { paddingLeft: `${(this.depth - 1) * 15}px` }
      } else {
        return { paddingLeft: `${this.depth * 15}px` }
      }
    },
    selectedKPISet () {
      return this.$store.state.selectedKPISet
    }
  },
  watch: {
    searchText: {
      handler (newValue) {
        const trimmed = newValue.trim()
        if (trimmed === '') {
          this.showNodes = this.depth < this.autoOpenDepth
        } else {
          this.showNodes = true
        }
      },
      immediate: true
    },
    autoOpenDepth () {
      this.showNodes = this.depth < this.autoOpenDepth
    }
  },

  methods: {
    filterNode (node, searchText) {
      const nodeMatches = cleanNodeName(node.name).toLowerCase().includes(searchText.trim().toLowerCase())

      let filteredChildren = []
      if (node.nodes && node.nodes.length > 0) {
        filteredChildren = node.nodes
          .map(child => this.filterNode(child, searchText))
          .filter(child => child !== null)
      }

      if (nodeMatches || filteredChildren.length > 0) {
        return {
          ...node,
          nodes: filteredChildren
        }
      }

      return null
    },
    async selectKPISet (node) {
      this.$store.commit('SET_LOADING_STATUS', true)
      // we don't want to load the root, because the root is only used to structure the KPISet tree and is not relevant for the user.
      if (node.level !== 0) {
        await this.$store.dispatch('getKPISet', { mode: this.mode, id: node.id }).then(() => {
          this.$parent.kpiSetModalElementId = node.id
          this.$parent.kpiSetKeyInt++
        })
      }
      this.$store.commit('SET_LOADING_STATUS', false)
      window.scrollTo(0, 0)
    },
    toggleNodes () {
      this.showNodes = !this.showNodes
    }
  }
}
</script>

<style lang="scss" scoped>
.kpiSet-tree {
  .cont-icon-KPISet svg {
    margin-top: -3px;
  }
  .kpiSet-name:hover {
    font-weight: bold;
  }
}
</style>
